module.exports = __webpack_public_path__ + "img/arrow-down-pri.01d5629a.png";